import { useRef, useState } from "react";
import CTAButton from "../CTAButton/CTAButton";
import FoldedPopup from "../FoldedPopup/FoldedPopup";
import PlusIcon from "../PlusIcon/PlusIcon";
import { Slider, ThemeProvider, createTheme } from "@mui/material";

import "./EditCustomSchedulePopup.scss";
import WhiteButton from "../WhiteButton/WhiteButton";
import { MultipleLineChart } from "../MultipleLineChart/MultipleLineChart";
import { useEffect } from "react";
import Sparkles from "react-sparkle";
import ScheduleItem from "../ScheduleItem/ScheduleItem";
import { useNavigate } from "react-router-dom";
import { edit_study_plan } from "../../network/communication";

function getSliderPercentageByLearningSpeed(speed) {
  if (speed === 1) {
    return 0;
  } else if (speed === 2) {
    return 33;
  } else if (speed === 3) {
    return 66;
  } else if (speed === 4) {
    return 100;
  }
}

function EditCustomSchedulePopup(props) {
  const navigate = useNavigate();

  const editCustomSchedulePopupEnabled = props.editCustomSchedulePopupEnabled;
  const setEditCustomSchedulePopupEnabled =
    props.setEditCustomSchedulePopupEnabled;

  const [howOftenPopup, setHowOftenPopup] = useState(false);

  const oftenValueToString = ["Slow", "Moderate", "Fast", "Lightning fast"];
  const [scheduleReadyPopup, setScheduleReadyPopup] = useState(false);

  const [learningSpeed, setLearningSpeed] = useState(
    props.setdata.study_plan.often_value + 1
  );

  const [oftenValue, setOftenValue] = useState(
    getSliderPercentageByLearningSpeed(learningSpeed)
  );

  const [oftenSliderLabel, setOftenSliderLabel] = useState(
    oftenValueToString[learningSpeed - 1]
  );

  const totalTerms = props.term_count; // Initialize this with the total number of terms in the set.
  const [daysTo100, setDaysTo100] = useState(null);
  const [daysTo100QuizzyPlus, setDaysTo100QuizzyPlus] = useState(null);
  const [activeLearningPath, setActiveLearningPath] = useState(0);
  const [clickedButton, setClickedButton] = useState(false);

  const user = props.user;
  const setid = props.setid;
  const QUIZZY_PLUS_PREMIUM_MIN_DAYS_BEFORE_TEST = 5;
  const BASIC_MIN_DAYS_BEFORE_TEST = 10;
  const lrm_data = props.lrm_data;

  const theme = createTheme({
    palette: {
      primary: {
        main: "#8358E8",
      },
    },
  });

  var [todayISO] = new Date().toISOString().split("T");
  var today = new Date();
  var minimumDaysBeforeTest = new Date(today);
  minimumDaysBeforeTest.setDate(
    minimumDaysBeforeTest.getDate() +
      (user.membership > 2
        ? QUIZZY_PLUS_PREMIUM_MIN_DAYS_BEFORE_TEST
        : BASIC_MIN_DAYS_BEFORE_TEST)
  ); // Add 3 days to the current date
  var [minimumDaysBeforeTestISO] = minimumDaysBeforeTest
    .toISOString()
    .split("T");

  const maxTermsPerDay = totalTerms;
  const [testDate, setTestDate] = useState(props.setdata.psd.test.test_date);

  const marks = [
    {
      value: 0,
      //label: "Not very often",
    },
    {
      value: 33,
      //label: "Often",
    },
    {
      value: 66,
      //label: "Very often",
    },
    {
      value: 100,
      //label: "Extremely often",
    },
  ];

  function getOftenValueByLearningSpeed(learningSpeed) {
    if (learningSpeed === 1) {
      return 0;
    } else if (learningSpeed === 33) {
      return 1;
    } else if (learningSpeed === 66) {
      return 2;
    } else if (learningSpeed === 100) {
      return 3;
    }
  }

  const [projectedProgress, setProjectedProgress] = useState({
    fill: [],
    labels: [],
  });

  const getStartingPhase = () => {
    if (lrm_data[0] === 0) {
      // No learning cards
      return "reviewing";
    }
    return "learning";
  };

  const getStartingProgress = () => {
    let totalTerms = lrm_data[0] + lrm_data[1] + lrm_data[2];

    return (lrm_data[1] * 0.5) / totalTerms + lrm_data[2] / totalTerms;
  };

  // Generate a list of dates between the current date and the day after the test date.
  const generateDateRange = (startDate, endDate) => {
    let dates = [];
    let current = new Date(startDate);
    endDate = new Date(endDate);
    endDate.setDate(endDate.getDate() + 1); // Ensure end date is included

    while (current <= endDate) {
      dates.push(formatDate(current)); // Use formatDate for consistent formatting
      current.setDate(current.getDate() + 1);
    }

    return dates;
  };

  const updateProgress = (lastProgress, day, speed, totalTerms) => {
    let expectedProgress = Math.min(
      (totalTerms * Math.pow((day + 1) * speed, 1)) / Math.pow(totalTerms, 1),
      totalTerms
    );

    return Math.min(
      lastProgress + (expectedProgress / totalTerms) * (100 - lastProgress),
      100
    );
  };
  // Modified generateProgressData Function
  const generateProgressData = (startDate, endDate, speed, totalTerms) => {
    let numDays = Math.round((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
    let progress = [];
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    // Fill past dates with zeros
    while (startDate < today) {
      progress.push(0); // Zero for past dates
      startDate.setDate(startDate.getDate() + 1);
    }

    let lastProgress = getStartingProgress() * 100; // Start calculating from today
    progress.push(lastProgress); // Add the starting progress for today

    // Calculate progress starting from today
    for (let i = 1; i < numDays - progress.length + 1; i++) {
      let expectedProgress = Math.min(
        (totalTerms * Math.pow((i + 1) * speed, 1)) / Math.pow(totalTerms, 1),
        totalTerms
      );

      let progressPercentage = Math.min(
        lastProgress + (expectedProgress / totalTerms) * (100 - lastProgress),
        100
      );

      lastProgress = progressPercentage;
      progress.push(progressPercentage);
    }

    return progress;
  };

  // Function to format date in 'MM/DD/YYYY' format
  function formatDate(date) {
    var month = date.getMonth() + 1; // getMonth() returns 0-11
    var day = date.getDate();
    var year = date.getFullYear();
    return month + "/" + day + "/" + year;
  }

  useEffect(() => {
    // This function will calculate the number of days to reach 100% progress
    const calculateDaysTo100 = (totalTerms, learningSpeed) => {
      let day = 0;
      // Calculate the delay based on the learning speed
      let delay = learningSpeed <= 2 ? 3 : 2;
      while (day < totalTerms) {
        if (day < delay) {
          day++;
          continue; // No progress during the delay period
        }
        let expectedProgress =
          (totalTerms * Math.pow((day + 1 - delay) * learningSpeed, 1)) /
          Math.pow(totalTerms, 1);
        if (expectedProgress >= totalTerms) {
          break;
        }
        day++;
      }
      return day;
    };
    // This function will calculate the number of days to reach 100% progress with maximum learning speed
    const calculateDaysTo100WithMaxSpeed = (totalTerms, maxTermsPerDay) => {
      return calculateDaysTo100(totalTerms, 4, maxTermsPerDay); // 4 is maximum learning speed
    };

    if (testDate && props?.setdata?.psd) {
      // Explicitly set the time to midnight

      let todayDate = new Date();
      todayDate.setHours(0, 0, 0, 0);

      let startDate = todayDate;

      const recallProgress = props.setdata.psd.recall_progress[0];

      if (recallProgress) {
        const firstEntryInRecall = Object.keys(recallProgress)[0];
        startDate = new Date(firstEntryInRecall);
      }

      startDate.setHours(0, 0, 0, 0);
      let endDate = new Date(`${testDate}T00:00:00`);
      endDate.setDate(endDate.getDate()); // Add one day to the end date

      // Generate Date Range
      const dateRange = generateDateRange(startDate, endDate);

      // Generate Progress Data
      const projectedProgressData = generateProgressData(
        startDate,
        endDate,
        learningSpeed,
        totalTerms
      );

      const projectedProgressQuizzyPlusData = generateProgressData(
        startDate,
        endDate,
        4,
        totalTerms
      );

      const daysTo100 = calculateDaysTo100(totalTerms, learningSpeed);

      // Ensure testDate is in a recognized format, e.g., 'YYYY-MM-DD'
      const testDate_DateType = endDate;

      const testDateLabelFormatted = formatDate(testDate_DateType);

      // Calculate the day after the test date
      const testDateNextDay = new Date(testDate_DateType);
      testDateNextDay.setDate(testDateNextDay.getDate() + 1);

      // Calculate Crunch Time start date
      const crunchTimeStart = new Date(testDate_DateType);
      crunchTimeStart.setDate(crunchTimeStart.getDate() - 3);

      const myProg = {
        fill: [
          {
            title: "Your Progress",
            color: "#8358E8",
            data: [],
          },
          {
            title: "Projected Progress",
            color: "#7B7B7B",
            borderDash: [20, 20], // Add the dashed line style
            data: projectedProgressData,
          },
        ],
        labels: dateRange,
      };
      // Integrate Recall Progress

      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set today to midnight for comparison
      let lastKnownValue = 0;

      dateRange.forEach((dateLabel) => {
        const date = new Date(dateLabel);
        const recallDateKey = formatDate(date); // Ensure the key format matches

        if (recallProgress.hasOwnProperty(recallDateKey)) {
          lastKnownValue = recallProgress[recallDateKey];
          myProg.fill[0].data.push(lastKnownValue);
        } else if (date <= today) {
          // Use the last known value instead of 0
          myProg.fill[0].data.push(lastKnownValue);
        }
      });

      const [year, month, day] = testDate.split("-");

      myProg.annotations = {
        test_date: {
          type: "line",
          xMin: testDateLabelFormatted,
          xMax: testDateLabelFormatted,
          yMin: 0,
          yMax: "max",
          backgroundColor: "rgba(255, 91, 145, 0.5)",
          borderColor: "rgba(255, 91, 145, 0.5)", // Red color for Test Date
          label: {
            display: true,
            content: `Test Date`,
            backgroundColor: "rgba(255, 91, 145, 0.5)",
            xAdjust: -30, // Adjust along x-axis to prevent overlap
            yAdjust: 15, // Adjust along y-axis to prevent overlap
            font: {
              family: "Plus Jakarta Sans",
              weight: 600,
              size: 16,
            },
          },
        },
      };

      console.log(myProg);

      setProjectedProgress(myProg);

      setDaysTo100(daysTo100);
      setDaysTo100QuizzyPlus(
        calculateDaysTo100WithMaxSpeed(totalTerms, maxTermsPerDay)
      );
    }
  }, [testDate, learningSpeed, totalTerms]);

  return (
    editCustomSchedulePopupEnabled && (
      <>
        <FoldedPopup
          noImage={false}
          closeButton={true}
          enabled={editCustomSchedulePopupEnabled}
          setEnabled={(enabled) => {
            setEditCustomSchedulePopupEnabled(enabled);
            setHowOftenPopup(enabled);
          }}
          className="how-popup2"
          rightSideContents={
            <>
              <h1 className="title">Your Progress</h1>
              <p className="caption">Here's how your learning looks like.</p>
              {projectedProgress?.fill?.length > 0 && (
                <div className="projected-progress-chart">
                  <MultipleLineChart config={projectedProgress} />
                </div>
              )}
            </>
          }
        >
          <h1 className="how-often-header">
            {/*How often do you want to review these terms?*/}
            Learning Speed
          </h1>
          <p className="based-on-learning">
            You can modify your learning speed here.
          </p>
          <div className="center">
            <div className="slider">
              <a className="slider-label">
                {oftenSliderLabel === "Lightning fast" ? (
                  <span className="lightning-fast-text">
                    {oftenSliderLabel}
                  </span>
                ) : (
                  oftenSliderLabel
                )}{" "}
                {(oftenSliderLabel === "Fast" ||
                  oftenSliderLabel === "Lightning fast") && (
                  <PlusIcon style={{ marginLeft: "10px" }} />
                )}
              </a>
              <ThemeProvider theme={theme}>
                <Slider
                  color="primary"
                  value={oftenValue}
                  step={null}
                  marks={marks}
                  valueLabelDisplay="off"
                  getAriaValueText={() => {
                    return false;
                  }}
                  sx={{
                    "& .MuiSlider-track": {
                      height: "10px",
                    },
                    "& .MuiSlider-rail": {
                      height: "10px",
                      background: "#C8C8C8",
                      opacity: 1,
                    },
                    "& .MuiSlider-thumbColorPrimary": {
                      background: "white",
                      filter: "drop-shadow(0px 0px 15px rgba(0, 0, 0, 16%))",
                      width: "26px",
                      height: "26px",
                      boxShadow: "none",
                      "::before": {
                        boxShadow: "none",
                      },
                    },
                  }}
                  onChange={function (e, x) {
                    if (x === 0) {
                      setOftenSliderLabel("Slow");
                      setLearningSpeed(1);
                    } else if (x === 33) {
                      setOftenSliderLabel("Moderate");
                      setLearningSpeed(2);
                    } else if (x === 66) {
                      setOftenSliderLabel("Fast");
                      setLearningSpeed(3);
                    } else if (x === 100) {
                      setOftenSliderLabel("Lightning fast");
                      setLearningSpeed(4);
                    }
                    setOftenValue(x);
                  }}
                />
              </ThemeProvider>
            </div>
          </div>
          <p className="based-on-learning">
            Based on your learning speed, it may take{" "}
            <span
              style={{ color: "#8358E8", fontWeight: 600, fontSize: "20px" }}
            >
              {daysTo100}
            </span>{" "}
            days to master all terms.
          </p>
          <h1 className="how-often-header">Test Date</h1>
          <p className="based-on-learning">
            Did your test get rescheduled? Modify it here.
          </p>
          <input
            type="date"
            className="add-test-date-picker"
            min={minimumDaysBeforeTestISO}
            defaultValue={testDate}
            onChange={(e) => {
              setTestDate(e.target.value);
            }}
          ></input>
          {user.membership < 3 ? (
            <>
              <WhiteButton
                text="Confirm"
                disabled={clickedButton || (user.membership < 1 && learningSpeed > 2)}
                onClick={() => {
                  if (learningSpeed > 2 && user.membership < 1) {
                    return false;
                  }
                  setClickedButton(true);

                  edit_study_plan(
                    setid,
                    {
                      test_date: testDate,
                      often_value: learningSpeed - 1,
                      learning_style: activeLearningPath,
                    },
                    (data) => {
                      if (data.success) {
                        
                        window.location.reload();
                      }
                    }
                  );
                }}
              ></WhiteButton>
            </>
          ) : (
            <>
              <CTAButton
                text="Confirm"
                color="purple"
                disabled={clickedButton}
                onClick={() => {
                  setClickedButton(true);
                  edit_study_plan(
                    setid,
                    {
                      test_date: testDate,
                      often_value: learningSpeed,
                      learning_style: activeLearningPath,
                    },
                    (data) => {
                      if (data.success) {
                        window.location.reload();
                      }
                    }
                  );
                }}
              ></CTAButton>
            </>
          )}
        </FoldedPopup>
      </>
    )
  );
}

export default EditCustomSchedulePopup;
